import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

import ConfirmationCard from '../../components/Shared/ConfirmationCard';
import { Title, Span } from '../../components/Shared/TitleSuccess';
import { copyFor } from '../../copy/copy';

const TitleComponent = props => (
    <Title>
        {props.useLocalRepresentative ? (
            props.localRepresentativeEmailState > 1 ? (
                <Span>{copyFor('feedback', 'representatives', 'email')}</Span>
            ) : (
                <Span>
                    {copyFor('feedback', 'singleRecipient', 'email', undefined, {
                        recipientName: 'Rep ' + props.repFullName
                    })}
                </Span>
            )
        ) : (
            <Span>
                {copyFor('feedback', 'singleRecipient', 'email', undefined, {
                    recipientName: props.recipientMask
                })}
            </Span>
        )}
    </Title>
);

TitleComponent.propTypes = {
    repFullName: PropTypes.string,
    recipientMask: PropTypes.string,
    useLocalRepresentative: PropTypes.bool,
    localRepresentativeEmailState: PropTypes.number
};

const EmailAction = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            rightAlign
            useLocalRepresentative={props.useLocalRepresentative}
            thankYouText={props.thankYouText}
            thankYouTitle={props.thankYouTitle}
            peopleCount={props.peopleCount}
            titleComponent={
                <TitleComponent
                    repFullName={props.repFullName}
                    recipientMask={props.recipientMask}
                    useLocalRepresentative={props.useLocalRepresentative}
                    localRepresentativeEmailState={props.localRepresentativeEmailState}
                />
            }
            {...props}
        />
    </TransitionContainerNoExit>
);

EmailAction.propTypes = {
    repFullName: PropTypes.string,
    recipientMask: PropTypes.string,
    peopleCount: PropTypes.string.isRequired,
    thankYouText: PropTypes.string.isRequired,
    thankYouTitle: PropTypes.string,
    useLocalRepresentative: PropTypes.bool,
    localRepresentativeEmailState: PropTypes.number
};

export default connect(
    state => ({
        repFullName: state.localRep.localRepData.representative
            ? state.localRep.localRepData.representative[0].fullName
            : '',
        recipientMask: state.email.recipientMask,
        peopleCount:
            state.email.completeEmail !== undefined
                ? state.email.completeEmail.endUsersCount
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : '',
        thankYouText: state.email.successInfo.thankYouText || '',
        thankYouTitle: state.email.successInfo.thankYouTitle,
        useLocalRepresentative: state.email.successInfo.useLocalRepresentative,
        localRepresentativeEmailState: state.email.successInfo.localRepresentativeState
    }),
    {}
)(EmailAction);



// WEBPACK FOOTER //
// ./src/containers/Email/EmailSuccess.jsx